// extracted by mini-css-extract-plugin
export default {"container":"drawing-manager-control_container__ipvyD","action":"drawing-manager-control_action__h+Tv5","action-active":"drawing-manager-control_action-active__bd3TY"};